import React, { useCallback, useEffect, useMemo, useState } from "react";
import CardsBorder from "../../../components/Cards/CardsBorder";
import { ReactComponent as GreenEye } from "../../../assets/svgs/greenEye.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/svgs/deleteIcon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/svgs/downlaod.svg";
import { ReactComponent as UploadIcon } from "../../../assets/svgs/upload.svg";
import { Tables } from "../../../components/Elements/Tables/Tables";
import SearchBar from "../../../components/Elements/Search/SearchBar";
import TextStyles from "../../../components/Elements/TextStyles/TextStyles";
import { getApi } from "../../../api/api_instance";
import { API_URLS } from "../../../api/apiUrls";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

const DynamicForms = ({ projectId, clientId }) => {
  const [searchItem, setSearchItem] = useState("");
  const [tableData, setTableData] = useState([]);
  const [popup, setPopup] = useState({
    visible: false,
    type: "",
    title: "",
    message: "",
  });
  const navigate = useNavigate();

  const showPopup = (type, title, message) => {
    setPopup({ visible: true, type, title, message });

    setTimeout(() => {
      setPopup({ visible: false, type: "", title: "", message: "" });
    }, 3000); // Close after 3 seconds
  };

  const headers = useMemo(
    () => [
      { label: "Sr. No.", key: "serial" },
      { label: "Form Title", key: "formTitle" },
      { label: "Assigned On", key: "assignedOn" },
      { label: "Action", key: "action" },
    ],
    []
  );

  const fetchTableData = useCallback(
    async (projectId) => {
      try {
        const response = await getApi({
          apiUrl: API_URLS.GET_CUSTOM_FORM_BY_PROJECTID(projectId),
        });
        if (response?.success) {
          const data = response.data.map((item, index) => ({
            key: item._id,
            serial: index + 1,
            formTitle: item.title,
            assignedOn: dayjs(item.createdAt).format("DD/MM/YYYY"),
            action: (
              <div className="flex gap-3">
                <GreenEye
                  style={{ fontSize: "18px", cursor: "pointer" }}
                  onClick={() => {
                    navigate(
                      `/dynamic-forms/${item._id}/all-questions?clientId=${clientId}`
                    );
                  }}
                />
              </div>
            ),
          }));
          setTableData(data);
        }
      } catch (error) {
        console.error("Error fetching dynamic forms:", error);
      }
    },
    [clientId, navigate]
  );

  // const tableData = useMemo(() => [
  //   {
  //     serial: 1,
  //     formTitle: "BASIC DETAILS FORM",
  //     assignedOn: "01/02/2023",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 2,
  //     formTitle: "BRSR",
  //     assignedOn: "01/02/2023",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 3,
  //     formTitle: "COPORATE OFFICE - SCOPE 1 & 2",
  //     assignedOn: "01/02/2023",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 4,
  //     formTitle: "COPORATE OFFICE - SCOPE 3",
  //     assignedOn: "05/06/2023",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  //   {
  //     serial: 5,
  //     formTitle: "EMPLOYEE FORM",
  //     assignedOn: "08/06/2023",
  //     action: (
  //       <div className="flex gap-2">
  //         <GreenEye />
  //       </div>
  //     ),
  //   },
  // ]);

  useEffect(() => {
    if (projectId) {
      fetchTableData(projectId);
    }
  }, [clientId]);

  return (
    <div>
      <CardsBorder>
        <div>
          <div>
            <div className="px-10 pb-4 flex justify-between">
              <div className="flex gap-16">
                <div className="flex items-center  gap-2 text-xl  font-bold">
                  <TextStyles color="gradient">Dynamic Survey Forms</TextStyles>
                </div>
                <SearchBar
                  width="400px"
                  onSearch={(value) => {
                    setSearchItem(value);
                    console.log(searchItem);
                  }}
                />
              </div>
              {/* <div className="flex gap-2 ">
                <CustomButton
                  buttonType="primary"
                  variant="ok"
                  buttonText="Assign Form"
                  className="text-xs h-[45px] px-8"
                  // onClick={handleOpenAddNew}
                />
                <CustomButton
                  buttonType="primary"
                  variant="ok"
                  buttonText="Add New"
                  className="text-xs h-[45px] px-8"
                  // onClick={handleOpenAddNew}
                />
              </div> */}
            </div>
            <Tables data={tableData} headers={headers} pageSize={5} />
          </div>
        </div>
      </CardsBorder>
    </div>
  );
};

export default DynamicForms;
